(function () {
  function initStickyCta() {
    if (window.innerWidth >= 768) return;

    document.querySelectorAll('[data-js-sticky-cta]').forEach(function (wrapper) {
      var btn = wrapper.querySelector('button');
      if (!btn) return;

      var fixed = document.createElement('div');
      fixed.className = 'lp-pdp__fixed-cta';
      fixed.setAttribute('aria-hidden', 'true');

      var clone = btn.cloneNode(true);
      clone.removeAttribute('id');
      clone.removeAttribute('aria-controls');
      clone.removeAttribute('aria-expanded');
      clone.setAttribute('tabindex', '-1');
      fixed.appendChild(clone);
      document.body.appendChild(fixed);

      // Forward clicks on clone to the real button
      clone.addEventListener('click', function () {
        btn.click();
      });

      // Keep the clone in sync with the real button (text, attrs, disabled state).
      // The personalize/ATC button label and data-* attrs change when the user picks
      // an out-of-stock variant — without this the sticky clone gets stale.
      function syncClone() {
        if (clone.innerHTML !== btn.innerHTML) clone.innerHTML = btn.innerHTML;
        clone.disabled = btn.disabled;
        clone.className = btn.className;
        clone.setAttribute('tabindex', '-1');
        if (btn.dataset.lpBisNotify === 'true') {
          clone.dataset.lpBisNotify = 'true';
        } else {
          delete clone.dataset.lpBisNotify;
        }
      }
      var mo = new MutationObserver(syncClone);
      mo.observe(btn, { attributes: true, childList: true, subtree: true, characterData: true });
      syncClone();

      var observer = new IntersectionObserver(
        function (entries) {
          // Show fixed bar only when original button has scrolled above viewport
          var above = entries[0].boundingClientRect.bottom < 0;
          fixed.classList.toggle('is-visible', above);
        },
        { threshold: 0 }
      );
      observer.observe(btn);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyCta);
  } else {
    initStickyCta();
  }
})();
